var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDate = function SvgDate(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 4.5H16.5V6H18C19.6569 6 21 7.34315 21 9V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V9C3 7.34315 4.34315 6 6 6H7.5V4.5H9V6H15V4.5ZM7.5 7.5V9H9V7.5H15V9H16.5V7.5H18C18.8284 7.5 19.5 8.17157 19.5 9V18C19.5 18.8284 18.8284 19.5 18 19.5H6C5.17157 19.5 4.5 18.8284 4.5 18V9C4.5 8.17157 5.17157 7.5 6 7.5H7.5ZM7.5 12H9V13.5H7.5V12ZM12.75 12H11.25V13.5H12.75V12ZM15 12H16.5V13.5H15V12ZM9 15H7.5V16.5H9V15ZM11.25 15H12.75V16.5H11.25V15ZM16.5 15H15V16.5H16.5V15Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 4.5H16.5V6H18C19.6569 6 21 7.34315 21 9V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V9C3 7.34315 4.34315 6 6 6H7.5V4.5H9V6H15V4.5ZM7.5 7.5V9H9V7.5H15V9H16.5V7.5H18C18.8284 7.5 19.5 8.17157 19.5 9V18C19.5 18.8284 18.8284 19.5 18 19.5H6C5.17157 19.5 4.5 18.8284 4.5 18V9C4.5 8.17157 5.17157 7.5 6 7.5H7.5ZM7.5 12H9V13.5H7.5V12ZM12.75 12H11.25V13.5H12.75V12ZM15 12H16.5V13.5H15V12ZM9 15H7.5V16.5H9V15ZM11.25 15H12.75V16.5H11.25V15ZM16.5 15H15V16.5H16.5V15Z",
    fill: "currentColor",
    fillOpacity: 0.2
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "date.7666c7393071db2a6b25ce9d730e209b.svg";